import { createApparatus } from "apparatus/library";
import { P } from "apparatus/library/common";
import { AddApparatus, Deselect, Select } from "command/basic";
import { commandProcessor, Sequence } from "command/command";
import { Path, Tool } from "paper";
import store from "store/store";
export class FreehandTool extends Tool {
    constructor(app) {
        super();
        this.app = app;
        this.onMouseDown = () => {
            var _a;
            this.app.setIsInteracting(true);
            (_a = this.path) === null || _a === void 0 ? void 0 : _a.remove();
            this.path = new Path();
            this.path.selected = true;
        };
        this.onMouseDrag = (event) => {
            if (!this.path)
                return;
            this.path.add(event.point);
        };
        this.onMouseUp = () => {
            this.app.setIsInteracting(false);
            const path = this.path;
            if (!path)
                return;
            // Clean up the path first.
            path.simplify();
            path.smooth();
            // Convert path points to segments as array.
            let points = [];
            for (let segment of path.segments) {
                const point = P(segment.point.x, segment.point.y);
                const handleOut = segment.handleOut.x == 0 && segment.handleOut.y == 0 ? undefined : P(segment.handleOut.x, segment.handleOut.y);
                const handleIn = segment.handleIn.x == 0 && segment.handleIn.y == 0 ? undefined : P(segment.handleIn.x, segment.handleIn.y);
                if (handleOut) {
                    points.push([p(point), p(handleIn), p(handleOut)]);
                }
                else if (handleIn) {
                    points.push([p(point), p(handleIn)]);
                }
                else {
                    points.push([p(point)]);
                }
            }
            // Find the center of the path.
            const center = path.bounds.center;
            // Apparatus data.
            const apparatusData = createApparatus("__freehand", center);
            apparatusData.appearance["points"] = points;
            commandProcessor.execute(new Sequence([
                new AddApparatus([apparatusData]),
                new Deselect(store.selectedObjectsID()),
                new Select([apparatusData.id])
            ]));
            // Remove path.
            path.remove();
            this.path = undefined;
        };
    }
}
function p(point) {
    if (point === undefined)
        return undefined;
    return [point.x.round(), point.y.round()];
}
